import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Input } from '../../../../../components';
import { useAutosizeTextArea } from '../../../../../hooks'; // Adjust the import path as needed

const ConversationTitleTextArea = styled(Input)`
  width: 100%;
  font-family: var(--font-family-title);
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 1.5;
  letter-spacing: 0;
  resize: none;
  box-sizing: border-box;
`;

const EditFormContainer = styled.div`
  display: flex;
  column-gap: 6px;
  width: 100%;
`;

const EditTitleForm = ({ title, onTitleUpdate, setChatTitle }) => {
  const textAreaRef = useAutosizeTextArea(title);

  useEffect(() => {
    if (textAreaRef.current) {
      textAreaRef.current.focus();
      const { length } = textAreaRef.current.value;
      textAreaRef.current.setSelectionRange(length, length);
    }
  }, [textAreaRef]);

  const handleKeyDown = useCallback(
    (evt) => {
      if (evt.key === 'Enter') {
        onTitleUpdate();
      }
    },
    [onTitleUpdate]
  );

  return (
    <EditFormContainer>
      <ConversationTitleTextArea
        value={title}
        ref={textAreaRef}
        onChange={(e) => setChatTitle(e.target.value)}
        as='textarea'
        wrap='hard'
        maxLength={100}
        rows={1}
        autoFocus
        onKeyDown={handleKeyDown}
      />
    </EditFormContainer>
  );
};

EditTitleForm.propTypes = {
  title: PropTypes.string.isRequired,
  onTitleUpdate: PropTypes.func.isRequired,
  setChatTitle: PropTypes.func.isRequired
};

export { EditTitleForm };
